import InventorisationIcon from './component'

export default InventorisationIcon
